import script from "./ColorField.vue?vue&type=script&setup=true&lang=js"
export * from "./ColorField.vue?vue&type=script&setup=true&lang=js"

import "./ColorField.vue?vue&type=style&index=0&id=f6dd67f8&scoped=true&lang=css"

import exportComponent from "/home/dragos/Work/cozmoslabs-ddev/translatepress/wp-content/plugins/translatepress/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f6dd67f8"]])

export default __exports__